import type { GdprCategory, ReadResult, BaseStorageFrontend } from "./storage/GdprStorage";
export type JsonStorageFrontend = {
	read: (key: string) => any;
	put: (key: string, value: any, category: GdprCategory, optCookieOptions?: Record<string, any> | null) => boolean;
	remove: (key: string) => boolean;
};

/**
 * Delegates to another storage and transforms all values to json (and back). Note that keys are not transformed,
 * and should be strings.
 * The other storage must provide the functions "get", "put", and "remove".
 */
export const JSONHandlingStorage = function (baseStore: BaseStorageFrontend): JsonStorageFrontend {
	if (!JSON || !JSON.stringify || !JSON.parse) {
		throw new Error("This device does not seem to provide JSON functions.");
	}

	if (!baseStore || !baseStore.put || !baseStore.get) {
		throw new Error("baseStore must provide put and get functions");
	}

	const read = function (key: string): any {
		const result: ReadResult = baseStore.get(key);

		try {
			if (!result.isAllowed) {
				return undefined;
			}

			return result.actualResult ? JSON.parse(result.actualResult) : null;
		} catch {
			console.warn("error loading json. result: ", result);
			return undefined;
		}
	};

	const put = function (
		key: string,
		value: any,
		category: GdprCategory,
		optCookieOptions?: Record<string, any> | null,
	): boolean {
		const json = JSON.stringify(value);
		return baseStore.put(key, json, category, optCookieOptions);
	};

	const remove = function (key: string): boolean {
		return baseStore.remove(key);
	};

	return {
		read,
		put,
		remove,
	};
};
